import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import TextAdjustLengthIcon from '@atlaskit/icon-lab/core/text-adjust-length';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

import { MakeLongerIcon } from '../../../../icons/prompt/makeLonger';
import type { ConvoAiFeatureId } from '../../../../utils/request/types';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

const intentSchemaId = 'make_longer.json';

export const makeLonger: EditorPluginAIConfigItemFactory = (options) => {
	let featureId: ConvoAiFeatureId =
		options?.product !== 'CONFLUENCE' && fg('platform_editor_ai_adf_prompts_in_all_products')
			? 'make_longer_adf_gpt41mini'
			: 'make_longer';
	let adfPrompt =
		options?.product !== 'CONFLUENCE' && fg('platform_editor_ai_adf_prompts_in_all_products');
	if (
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini')
	) {
		featureId = 'make_longer_adf_gpt41mini';
		adfPrompt = true;
	} else if (
		expValEqualsNoExposure('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash')
	) {
		featureId = 'make_longer_adf_v111';
		adfPrompt = true;
	}

	return {
		key: CONFIG_ITEM_KEYS.MAKE_LONGER,
		title: aiConfigItemMessages.makeLongerTitle,
		description: aiConfigItemMessages.makeLongerDescription,
		icon: () => <MakeLongerIcon />,
		statusLozengeType: 'beta',
		intentSchemaId,
		featureId,
		adfPrompt,
		requiresTextualContent: adfPrompt,
		getBackendModel: () => 'assistance-service',
		showInRefineDropdown: true,
		actions: {
			empty: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
			selection: [
				createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
				createReplace({ appearance: 'primary' }),
			],
		},
		get nestingConfig() {
			if (options?.isInDocumentStreamingEnabled) {
				return {
					id: 'adjust-length',
					parentTestId: 'adjust-length',
					parentTitle: aiConfigItemMessages.adjustLengthNestingParentTitle,
					shortTitle: aiConfigItemMessages.adjustLengthNestingParentShortTitle,
					icon: () => <TextAdjustLengthIcon label="" spacing="spacious" />,
				};
			}
			return undefined;
		},
	};
};

export const makeLongerWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (options) => ({
	config: makeLonger(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
